import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import PropTypes from 'prop-types';
import __t from '../../locales';
import { TreeTable, TreeState } from 'cp-react-tree-table';
import { Switch } from '@material-ui/core';

export const RateSwitchTable = forwardRef((props, ref) => {
    const [treeValue, setTreeValue] = useState(TreeState.createEmpty());

    useEffect(() => {
        const treeData = props.allRates.map(p => {
            return {
                data: {
                    id: p.id,
                    name: p.name,
                    productTypeCode: p.productTypeCode,
                    price: p.price,
                    quantity: p.quantity,
                    checked: Boolean(props.rates.find(pp => pp.id === p.id))
                }
            };
        });

        setTreeValue(TreeState.create(treeData));
    }, [props.allRates, props.rates]);

    useImperativeHandle(ref, () => ({
        getSelectedRates: () => {
            if (treeValue.hasData) {
                return treeValue.data.filter(p => p.data.checked).map(c => c.data);
            }
            return [];
        }
    }));

    return (
        <>
            <TreeTable
                value={treeValue}
                onChange={(newState) => setTreeValue(newState)}
                height={300}
            >
                <TreeTable.Column
                    grow={1}
                    renderCell={(row) => {
                        return (
                            <div style={{
                                height: "100%",
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                overflow: 'hidden',
                                whiteSpace: 'nowrap' 
                            }}>
                                {row.data.name}
                            </div>
                        )
                    }}
                    renderHeaderCell={() => <span>{__t('name')}</span>}
                />
                <TreeTable.Column
                    grow={0}
                    basis='50px'
                    renderCell={(row) => {
                        return (
                            <div style={{
                                height: "100%",
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "center"
                            }}>
                                <span>{row.data.productTypeCode == 'PRE' ? 'PASS' : 'ROT'}</span>
                            </div>
                        )
                    }}
                    renderHeaderCell={() => <span>{__t('type')}</span>}
                />
                <TreeTable.Column
                    grow={0}
                    basis='80px'
                    renderCell={(row) => {
                        return (
                            <div style={{
                                height: "100%",
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "center"
                            }}>
                                <span>{row.data.quantity}</span>
                            </div>
                        )
                    }}
                    renderHeaderCell={() => <span>{__t('quantity')}</span>}
                />
                <TreeTable.Column
                    grow={0}
                    basis='80px'
                    renderCell={(row) => {
                        return (
                            <div style={{
                                height: "100%",
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "center"
                            }}>
                                <span>{row.data.price ? String(row.data.price).replace('.', ',') : ''}</span>
                            </div>
                        )
                    }}
                    renderHeaderCell={() => <span>{`${__t('price')} (${__t('money_helper')})`}</span>}
                />
                <TreeTable.Column
                    grow={0}
                    basis='80px'
                    renderCell={(row) => {
                        return (
                            <div style={{
                                height: "100%",
                                display: "flex",
                                flexDirection: "row-reverse",
                                alignItems: "center",
                                justifyContent: "center"
                            }}>
                                <Switch
                                    checked={row.data.checked}
                                    onChange={() => {
                                        row.updateData({ ...row.data, checked: !row.data.checked });
                                    }}
                                />
                            </div>
                        )
                    }}
                    renderHeaderCell={() => <span></span>}
                />
            </TreeTable>
        </>
    );
});

RateSwitchTable.propTypes = {
    allRates: PropTypes.array,
    rates: PropTypes.array,
}